<ng-container
  [ngTemplateOutlet]="
    (isLoading$ | async) ? loading : feedbackSent ? success : fillOut
  "
></ng-container>

<ng-template #fillOut>
  @if (isDesktop) {
    <div class="flex flex-col py-2 mb-4 border-bottom">
      <div class="flex flex-row items-center px-4 justify-between">
        <h3 class="text-neutral-900 text-2xl font-semibold leading-[32px]">
          {{ 'feedback.title' | translate }}
        </h3>
        <button
          [mat-dialog-close]="null"
          dsw-medium-icon-button="none"
          dswSuffix
          mat-icon-button
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  } @else {
    <div class="flex flex-col" mat-dialog-title>
      <div class="flex flex-row items-center px-4 justify-start">
        <button [mat-dialog-close]="null" mat-button>
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'common.back' | translate }}</span>
        </button>
      </div>
    </div>
  }

  <form
    [formGroup]="formGroup"
    class="grow flex-col flex gap-4"
    mat-dialog-content
    cdkFocusInitial
  >
    <div class="grow flex-col flex gap-4 feedback">
      <div class="pb-6 flex-col flex gap-2">
        @if (!isDesktop) {
          <h3 class="text-neutral-900 text-2xl font-semibold leading-[32px]">
            {{ 'feedback.title' | translate }}
          </h3>
        }
        <div class="text-zinc-500 text-sm font-normal leading-[21px]">
          {{ 'feedback.info' | translate }}
        </div>
      </div>

      <div class="flex-col flex gap-1">
        <span
          class="grow shrink basis-0 text-neutral-900 text-xs font-semibold leading-none"
        >
          {{ 'common.email' | translate }}
        </span>

        <dsw-form-field class="w-100">
          <input formControlName="email" matInput placeholder="abc@mail.de" />
        </dsw-form-field>
      </div>

      <div>
        <span
          class="grow shrink basis-0 text-neutral-900 text-xs font-semibold leading-none"
        >
          {{ 'feedback.positive' | translate }}
        </span>

        <dsw-form-field class="w-100">
          <textarea formControlName="positive" matInput rows="5"></textarea>
        </dsw-form-field>
      </div>

      <div>
        <span
          class="grow shrink basis-0 text-neutral-900 text-xs font-semibold leading-none"
        >
          {{ 'feedback.negative' | translate }}
        </span>

        <dsw-form-field class="w-100">
          <textarea formControlName="negative" matInput rows="5"></textarea>
        </dsw-form-field>
      </div>

      <div class="flex flex-col gap-1 w-full">
        <span
          class="grow shrink basis-0 text-neutral-900 text-xs font-semibold leading-none"
          >{{ 'feedback.upload' | translate }}</span
        >
        <div class="flex flex-col w-full upload-frame">
          <button
            class="h-[40px] w-full"
            (click)="openFilePicker()"
            dsw-secondary-button
            dsw-medium-button
          >
            <mat-icon class="upload-icon">add</mat-icon>
            <span class="text-sm font-semibold">Dateien auswählen</span>
          </button>
        </div>
        <span
          class="grow shrink basis-0 fill-color-grey-dark text-xs font-normal leading-none"
          >{{ 'feedback.upload-hint' | translate }}</span
        >
      </div>
    </div>

    @for (file of files; track file; let index = $index) {
    <div class="upload-item-frame flex flex-row w-full gap-2">
      <div class="flex flex-col grow overflow-auto">
        <span class="text-black text-base">{{ file.name }}</span>
        <span class="text-color-grey-text text-sm">{{
          file.size | filesize
        }}</span>
      </div>
      <div class="flex items-center">
        <button
          (click)="removeFile(index)"
          dsw-small-icon-button="none"
          mat-icon-button
        >
          <mat-icon class="font-semibold text-black">delete_outlined</mat-icon>
        </button>
      </div>
    </div>
    }

    <div class="pb-8">
      <button
        (click)="onSubmitFeedback()"
        [disabled]="formGroup.invalid"
        class="w-100"
        dsw-primary-button
        type="submit"
        dsw-medium-button
      >
        {{ 'feedback.send_feedback' | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #success>
  <div class="grow flex-col flex" mat-dialog-content>
    <div class="flex flex-col grow justify-center items-center">
      <img
        alt="feedback_sent"
        height="200"
        ngSrc="assets/media/feedback-sent.svg"
        style="margin: 0"
        width="175"
      />
      <h2
        class="text-center text-black text-2xl font-medium font-['Inter'] leading-[32px] pb-2 pt-6"
      >
        {{ 'feedback.thanks_title' | translate }}
      </h2>
      <span
        class="text-center text-neutral-600 text-base font-normal font-['Inter'] leading-normal"
      >
        {{ 'feedback.thanks_text' | translate }}
      </span>
    </div>

    <div class="pb-8">
      <button
        [mat-dialog-close]="null"
        class="w-100"
        dsw-primary-button
        dsw-medium-button
      >
        {{ 'common.close' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="flex flex-col items-center justify-center" mat-dialog-content>
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
